import {
  GermanStateCode,
  LEAVE_ABSENCE_KIND_HINTS,
  LEAVE_ABSENCE_KIND_LABELS,
  type GermanStateCode as StateCode,
  type LeaveAbsenceKindCode,
} from '@gb-ticket/shared-types';

export const LEAVE_ABSENCE_KIND_LABEL = LEAVE_ABSENCE_KIND_LABELS;

export function leaveKindLabel(kind: LeaveAbsenceKindCode): string {
  return LEAVE_ABSENCE_KIND_LABELS[kind];
}

export function leaveKindHint(kind: LeaveAbsenceKindCode): string {
  return LEAVE_ABSENCE_KIND_HINTS[kind];
}

export const GERMAN_STATE_LABEL: Record<StateCode, string> = {
  [GermanStateCode.BW]: 'Baden-Württemberg',
  [GermanStateCode.BY]: 'Bayern',
  [GermanStateCode.BE]: 'Berlin',
  [GermanStateCode.BB]: 'Brandenburg',
  [GermanStateCode.HB]: 'Bremen',
  [GermanStateCode.HH]: 'Hamburg',
  [GermanStateCode.HE]: 'Hessen',
  [GermanStateCode.MV]: 'Mecklenburg-Vorpommern',
  [GermanStateCode.NI]: 'Niedersachsen',
  [GermanStateCode.NW]: 'Nordrhein-Westfalen',
  [GermanStateCode.RP]: 'Rheinland-Pfalz',
  [GermanStateCode.SL]: 'Saarland',
  [GermanStateCode.SN]: 'Sachsen',
  [GermanStateCode.ST]: 'Sachsen-Anhalt',
  [GermanStateCode.SH]: 'Schleswig-Holstein',
  [GermanStateCode.TH]: 'Thüringen',
};

export const LEAVE_CALENDAR_KIND_LABEL = {
  vacation: 'Erholungsurlaub',
  sick: 'Krankheit',
  training: 'Fortbildung',
  special: 'Sonderurlaub',
  unpaid: 'Unbezahlte Freistellung',
  comp_time: 'Freizeitausgleich',
  home_office: 'Homeoffice',
  business_trip: 'Dienstreise',
  away: 'Abwesend',
} as const;

export function leaveCalendarKindLabel(kind: keyof typeof LEAVE_CALENDAR_KIND_LABEL): string {
  return LEAVE_CALENDAR_KIND_LABEL[kind];
}

export const LEAVE_REQUEST_STATUS_LABEL = {
  draft: 'Entwurf',
  submitted: 'Eingereicht',
  approved: 'Genehmigt',
  rejected: 'Abgelehnt',
  cancelled: 'Zurückgezogen',
} as const;

export const LEAVE_EVENT_LABEL = {
  created: 'Angelegt',
  submitted: 'Eingereicht',
  approved: 'Genehmigt',
  rejected: 'Abgelehnt',
  cancelled: 'Zurückgezogen',
  updated: 'Geändert',
  substitute_set: 'Vertretung gesetzt',
  vacation_restored: 'Urlaubstage zurückgegeben',
} as const;

export function formatLeaveRange(startsOn: string, endsOn: string): string {
  const format = new Intl.DateTimeFormat('de-DE', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
  });
  const start = format.format(new Date(`${startsOn}T12:00:00`));
  const end = format.format(new Date(`${endsOn}T12:00:00`));
  return startsOn === endsOn ? start : `${start} – ${end}`;
}
